import React, { useState, useCallback } from 'react'
import { createStyles, makeStyles } from '@material-ui/styles'
import AppBar from '@material-ui/core/AppBar'
import ToolBar from '@material-ui/core/Toolbar'
import logo from '../../assets/img/icons/logo.png'
import logoNotext from '../../assets/img/icons/logo_no_text.png'
import { useDispatch, useSelector } from 'react-redux'
import {
  getSignedIn,
  getUserInfo,
  getUserRole,
} from '../../reducks/users/selectors'
import { push } from 'connected-react-router'
import { HeaderMenus, ClosableDrawer } from './index'
import { fetchProducts } from '../../reducks/products/operations'
import { useMediaQuery } from '@material-ui/core'
import BellController from '../notice/bell/BellController'
import { PERMISSIONS } from '../../constants/permissions'
import { useUserCartFavoriteSync } from '../../hooks/useUserCartFavoriteSync'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: '100vw',
  },
  menuBar: {
    backgroundColor: '#fff',
    color: '#444',
  },
  toolBar: {
    margin: '0 auto',
    maxWidth: 1024,
    width: '100%',
  },
  iconButtons: {
    margin: '0 0 0 auto',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  img: {
    height: 64,
    cursor: 'pointer',
  },
  orderDepInfo: {
    color: '#1C3E51',
  },
  info: {
    fontSize: '12px',
    [theme.breakpoints.up('md')]: {
      fontSize: '16px', // md以上の画面サイズの場合のフォントサイズ
    },
    padding: '0 10px',
    color: '#1C3E51',
    fontWeight: 'bold',
    textAlign: 'right',
    margin: 0,
  },
  alert: {
    color: 'red',
    fontWeight: 'bold',
    padding: '0 10px',
    margin: 0,
  },
  bell: {
    position: 'absolute',
    right: -30,
    top: 16,
  },
}))
const Header = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const isIphone = useMediaQuery('(max-width:600px)')
  const user = useSelector(getUserInfo)
  const isSignedIn = useSelector(getSignedIn)
  const userRole = useSelector(getUserRole)
  useUserCartFavoriteSync()
  const [sideBarOpen, setSideBarOpen] = useState(false)
  const handleDrawerToggle = useCallback(
    (event, isOpen) => {
      if (
        event.type === 'keydown' &&
        (event.key === 'Tab' || event.key === 'Shift')
      ) {
        return
      }
      setSideBarOpen(isOpen)
    },
    [setSideBarOpen]
  )
  const handleLogoClick = () => {
    isSignedIn && dispatch(fetchProducts('', '', ''))
    dispatch(push('/'))
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    } catch (error) {
      // just a fallback for older browsers
      window.scrollTo(0, 0)
    }
  }
  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.menuBar}>
        <ToolBar className={classes.toolBar}>
          <div className={classes.logo}>
            <img
              className={classes.img}
              src={isIphone ? logoNotext : logo}
              alt="MTW Logo"
              onClick={() => handleLogoClick()}
            />
            {user.isSignedIn &&
            (user.order_base_name === '' ||
              user.order_department_name === '') ? (
              <>
                <div className={classes.orderDepInfo}>
                  <p className={classes.alert}>{'発注部署'}</p>
                  <p className={classes.alert}>{'未設定'}</p>
                </div>
              </>
            ) : user.isSignedIn && !user.order_email ? (
              <div className={classes.orderDepInfo}>
                <p className={classes.alert}>{'発注担当'}</p>
                <p className={classes.alert}>{'未設定'}</p>
              </div>
            ) : (
              <>
                <div className={classes.orderDepInfo}>
                  <p className={classes.info}>{user.order_base_name}</p>
                  <p className={classes.info}>{user.order_department_name}</p>
                </div>
              </>
            )}
            {isSignedIn && userRole !== PERMISSIONS.VIEWER && (
              <div className={classes.bell}>
                <BellController />
              </div>
            )}
          </div>
          {isSignedIn && (
            <div className={classes.iconButtons}>
              <HeaderMenus handleDrawerToggle={handleDrawerToggle} />
            </div>
          )}
        </ToolBar>
      </AppBar>
      <ClosableDrawer open={sideBarOpen} onClose={handleDrawerToggle} />
    </div>
  )
}
export default Header
